import React from 'react';

// ── Retrowave scene — stars, clover sun, mountains, horizon, grid, glare ─────
// `splash` variant adds the striped 80s-sun slats (desktop clover stays solid).
const RetroScene = ({ splash = false }) => (
  <div className={`rw-scene${splash ? ' splash-scene' : ''}`} aria-hidden="true">
    <div className="rw-stars" />
    <div className="rw-sun">☘</div>
    <div className="rw-mountains rw-mountains-far" />
    <div className="rw-mountains rw-mountains-near" />
    <div className="rw-horizon" />
    <div className="rw-floor">
      <div className="rw-grid" />
    </div>
    <div className="rw-glare" />
  </div>
);

export default RetroScene;
